import { App } from 'antd';
import { captureError } from 'infra/monitoring/monitoring.utils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function isWebGLAvailable(): boolean {
  const canvas = document.createElement('canvas');
  return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') ?? canvas.getContext('experimental-webgl')));
}

export function useWebGLCheck() {
  const [t] = useTranslation();

  const { notification } = App.useApp();

  useEffect(() => {
    try {
      if (!isWebGLAvailable()) {
        notification.error({
          title: t('general.webgl.message'),
          description: t('general.webgl.description'),
          duration: 10
        });
      }
    } catch (e) {
      captureError(e, {
        errorType: 'ValidationError',
        crashScreen: false,
        domain: 'MapFeature'
      });
    }
  }, [t]);
}
